import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=ade5df7a&"
import script from "./LoginAs.vue?vue&type=script&lang=js&"
export * from "./LoginAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports